<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <span v-if="propNoIniciadosNoInvertidos.length === 0"
           style="font-size: 11px; color: #74C073;;font-weight: 600"
      >No hay tratamientos en esta Categoria </span>
  <div>
    <div v-for="(pad, ind1) in listPadecimientosAgregar" :key="'init-'+ind1">
      <EdicionPtiAgregarTratamiento
          v-if="!agrupadoPorOD"
          :tipoAgrupamiento="1"
          :listaDientesCatalogo="listaDientes"
          :lista-tratamientos-catalogo="arrayTratamientoFiltroCatalogo"
          :lista-padecimiento-catalogo="arrayPadecimientoCatalogo"
          :padecimiento-original="pad"
          :padecimiento-original-index="ind1"
          @desactivarApartado="eliminarTratamientoIndex"
          @padecimientoActualizado="pad = $event"
          :listaKitsProp="listaKitsProp"
          :indexExtra="'extr-' + ind1"
          :opcionAceptada="opcionAceptada"
      ></EdicionPtiAgregarTratamiento>
      <EdicionPtiAgregarTratamiento
          v-else
          :tipoAgrupamiento="2"
          :listaDientesCatalogo="listaDientes"
          :lista-tratamientos-catalogo="arrayTratamientoFiltroCatalogo"
          :lista-padecimiento-catalogo="arrayPadecimientoCatalogo"
          :padecimiento-original="pad"
          :padecimiento-original-index="ind1"
          @desactivarApartado="eliminarTratamientoIndex"
          @padecimientoActualizado="pad = $event"
          :listaKitsProp="listaKitsProp"
          :indexExtra="'extr-' + ind1"
          :opcionAceptada="opcionAceptada"
      ></EdicionPtiAgregarTratamiento>
    </div>
  </div>

  <div v-if="propNoIniciadosNoInvertidos.length > 0">
  <div v-for="(init, index) in propNoIniciadosNoInvertidos" :key="index">
    <b-card class="text-left" style="border: 0px; ">
      <b-card class="text-left" style="border: 0px;">
        <span v-if="!agrupadoPorOD" style="font-size: 11px; color: #79ACCE">
          <em class="dienteTratamiento"></em>
          {{init.nombreTratamiento}}
          <em v-if="edicionActiva && init.listPadecimientos.some(ls => ls.estatus === 0)" class="trash_svg" style=" width: 17px; padding-right: 2px; cursor: pointer"
              v-b-tooltip.hover.top.v-light
              title="Eliminar registros"
              @click="pasarEstatusEliminadoTxs(init.listPadecimientos)"/>
          <em v-if="edicionActiva && init.listPadecimientos.every(ls => ls.estatus === 2)" class="close_red" style=" width: 17px; padding-right: 2px; cursor: pointer"
              v-b-tooltip.hover.top.v-light
              title="Cancelar eliminación grupal"
              @click="quitarEstatusEliminadoTxs(init.listPadecimientos)"/>
        </span>
        <span v-if="agrupadoPorOD" style="font-size: 11px; color: #79ACCE">
          <em class="dienteTratamiento"></em>
          <span v-if="init.diente != 0"> {{init.diente}} </span>
          <span v-else> {{init.listPadecimientos[0].nombreDiente}} </span>

          <em v-if="edicionActiva && init.listPadecimientos.some(ls => ls.estatus === 0)" class="trash_svg" style=" width: 17px; padding-right: 2px; cursor: pointer"
              v-b-tooltip.hover.top.v-light
              title="Eliminar registros"
              @click="pasarEstatusEliminadoTxs(init.listPadecimientos)"/>
          <em v-if="edicionActiva && init.listPadecimientos.every(ls => ls.estatus === 2)" class="close_red" style=" width: 17px; padding-right: 2px; cursor: pointer"
              v-b-tooltip.hover.top.v-light
              title="Cancelar eliminación grupal"
              @click="quitarEstatusEliminadoTxs(init.listPadecimientos)"/>
        </span>

        <b-row class="m-0 bold">
          <b-col v-if="!agrupadoPorOD" class="leterSize p-0 columnas-col" style="border-right: #ECECEC 1px solid;">Od´s afectados</b-col>
          <b-col v-if="agrupadoPorOD" class="leterSize p-0 columnas-col" style="border-right: #ECECEC 1px solid;">Tratamiento</b-col>
          <b-col cols="2" class="leterSize bordeTable text-left p-0 pl-1 d-flex align-items-center">Padecimiento</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col">Cantidad Tratamiento</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col">Precio unitario</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col" v-if="aplicaPlan || aplicaPromo">Precio subtotal</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col" v-if="aplicaPlan">Descuento plan</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col" v-if="aplicaPromo">Descuento promo</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col">Inversión final</b-col>
          <b-col class="leterSize bordeTable p-0 text-center columnas-col" v-if="edicionActiva">Acciones</b-col>
        </b-row>


        <div v-for="(pad, ind1) in init.listPadecimientos" :key="'init-'+ind1">
          <b-row class="m-0" :class="pad.cambioTratamientoActivo? 'cambiarTratamientoClass' : ''">
            <em  class="trtKit_svg" v-if="pad.idKit !== null && pad.idKit !== 0 && !agrupadoPorOD" style="position:absolute; z-index: 1;"
                v-b-tooltip.hover.top.v-light
                :title="pad.nombreKits"
            ></em> <span style="color: #FFFFFF; font-size: 6px;position:absolute;">{{pad.nombreKits}}</span>
            <b-col v-if="!agrupadoPorOD" class="leterSize p-0 columnas-col" style="border-right: 1px solid #ECECEC">
              <b-button size="sm" variant="outline-info" pill disabled>
                <span class="leterSize" v-if="pad.numeroDiente != 0" > {{ pad.numeroDiente }}</span>
                <span class="leterSize" v-else > {{ pad.nombreDiente }}</span>
              </b-button>
            </b-col>
            <b-col v-if="agrupadoPorOD" class="leterSize p-0 columnas-col">
              <em  class="trtKit_svg" v-if="pad.idKit !== null && pad.idKit !== 0 "
                   v-b-tooltip.hover.top.v-light
                   :title="pad.nombreKits"
              ></em>
              <b-button size="sm" variant="outline-info" pill disabled class="ml-2 mr-2">
                <span class="leterSize">{{pad.tratamiento}}</span>
              </b-button>
            </b-col>
            <b-col cols="2"
                   class="leterSize bordeTable text-left pr-1 pl-1 pt-1 pb-1 d-flex align-items-center border-estatus-inicio"
                   :style="pad.estilos">
              {{ pad.nombrePadecimiento }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio"
                   :style="pad.estilos">
              {{ pad.cantidad }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio"
                   :style="pad.estilos">
              {{ pad.precioUnitario |monedaEntero }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio"
                   :style="pad.estilos" v-if="aplicaPlan || aplicaPromo">
              {{ pad.precioSubtotal | monedaEntero }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio"
                   :style="pad.estilos" v-if="aplicaPlan">
              {{ pad.montoValePlan | monedaEntero }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio"
                   :style="pad.estilos" v-if="aplicaPromo">
              {{ pad.montoPromocion | monedaEntero }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-medio"
                   :style="pad.estilos">
              {{ pad.inversionFinal | monedaEntero }}
            </b-col>
            <b-col class="leterSize bordeTable p-0 text-center columnas-col border-estatus-final"
                   :style="pad.estilos" v-if="edicionActiva">
              <em v-if="edicionActiva && pad.estatus == 0" class="flechasDirecciones_svg"
                  style=" width: 17px; padding-right: 2px; cursor: pointer"
                  v-b-tooltip.hover.top.v-light
                  title="Cambiar Tratamiento"
                  @click="cambiarTratamiento(pad, index, ind1)"/>

              <em v-if="edicionActiva && pad.estatus == 0" class="flechaVerde_svg"
                  style=" width: 17px; padding-right: 2px; cursor: pointer"
                  v-b-tooltip.hover.top.v-light
                  title="Pasar a Presentar"
                  @click="pasarAPresentar(pad, init.nombreTratamiento)"
              />
              <em v-if="edicionActiva && pad.estatus == 1" class="flechaAtras_svg"
                  style=" width: 17px; padding-right: 2px; cursor: pointer"
                  v-b-tooltip.hover.top.v-light
                  title="retirar de tratamientos a presentar"
                  @click="quitarDePresentar(pad, init.nombreTratamiento)"
              />


              <em v-if="edicionActiva && pad.estatus == 0 " class="trash_svg"
                  style=" width: 17px; padding-right: 2px; cursor: pointer"
                  v-b-tooltip.hover.top.v-light
                  title="Eliminar registro"
                  @click="pasarEstatusEliminadoTx(pad)"/>

              <em v-if="edicionActiva && pad.estatus == 2" class="close_red"
                  style=" width: 17px; padding-right: 2px; cursor: pointer"
                  v-b-tooltip.hover.top.v-light
                  title="Cancelar eliminación"
                  @click="quitarEstatusEliminadoTx(pad)"/>
            </b-col>
          </b-row>
          <EdicionPtiCambiarTratamiento v-if="pad.cambioTratamientoActivo"
                                        :tipo-agrupamiento="1"
                                        :lista-tratamientos-catalogo="arrayTratamientoFiltroCatalogo"
                                        :lista-padecimiento-catalogo="arrayPadecimientoCatalogo"
                                        @desactivarApartado="pad.cambioTratamientoActivo = $event"
                                        :padecimiento-original="pad"
                                        @listatratamientosCambiados="listatratamientosCambiados = $event"
          ></EdicionPtiCambiarTratamiento>

          <hr v-if="init.listPadecimientos.length !== 1 && init.listPadecimientos.length !== ind1 + 1"
              class="mt-2 mb-2">
        </div>

      </b-card>
    </b-card>
  </div>
  </div>
</div>
</template>

<script>
import EdicionPtiCambiarTratamiento from "@/version5/componentes/EdicionPtiCambiarTratamiento";
import EdicionPtiAgregarTratamiento from "@/version5/componentes/EdicionPtiAgregarTratamiento";
export default {
  name: "NoIniciadosNoInvertidos",
  components:{
    EdicionPtiCambiarTratamiento,
    EdicionPtiAgregarTratamiento
  },
  props: {
    propNoIniciadosNoInvertidos: Array,
    listPadecimientosAgregar:Array,
    arrayPadecimientoCatalogo:Array,
    arrayTratamientoFiltroCatalogo:Array,
    listaDientes:Array,
    edicionActiva: Boolean,
    agrupadoPorOD: Boolean,
    listaKitsProp: Array,
    opcionAceptada: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listatratamientosCambiados: [],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  computed: {
    aplicaPlan() {
      return this.propNoIniciadosNoInvertidos.some(p => p.listPadecimientos.some(l => l.montoValePlan !== 0 && l.montoValePlan !== null))
    },
    aplicaPromo() {
      return this.propNoIniciadosNoInvertidos.some(p => p.listPadecimientos.some(l => l.montoPromocion !== 0 && l.montoPromocion !== null))
    }
  },
  watch: {
    listatratamientosCambiados(){
      this.$emit("llenarCambiosTrts", this.listatratamientosCambiados )
    }
  },
  methods: {
    quitarDePresentar(item){
      item.estatus = 0;
      this.cambiarEstiloColumna(item, item.estatus)
    },
    pasarAPresentar(item, nombre){
      item.estatus = 1;
      this.cambiarEstiloColumna(item, item.estatus)
      this.$emit("llenarTratamientosPresentar", item, nombre)
    },
    pasarEstatusEliminadoTx(item) {
      item.estatus = 2;
      this.cambiarEstiloColumna(item, item.estatus)
    },
    quitarEstatusEliminadoTx(item) {
      item.estatus = 0;
      this.cambiarEstiloColumna(item, item.estatus)
    },
    pasarEstatusEliminadoTxs(padecimientos) {
      padecimientos.forEach(p => {
        if (p.estatus === 0) {
          p.estatus = 2;
          this.cambiarEstiloColumna(p, p.estatus)
        }
      })
    },
    quitarEstatusEliminadoTxs(padecimientos) {
      padecimientos.forEach(p => {
        if (p.estatus === 2) {
          p.estatus = 0;
          p.estilos = 'border-color: white';
        }
      })
    },
    cambiarEstiloColumna(item, estatus) {
      if (estatus === 1) {
        item.estilos = 'border-color: #94d993';
      } else if (estatus === 2) {
        item.estilos = 'border-color: #ea707e';
      } else if (estatus === 3) {
        item.estilos = 'border-color: #81cdd8';
      } else if (estatus === 4) {
        item.estilos = 'border-color: #94d993';
      } else {
        item.estilos = 'border-color: white';
      }
    },
    cambiarTratamiento(tratamiento, ind1, ind2){
      tratamiento.estatus = 3;
      this.propNoIniciadosNoInvertidos[ind1].listPadecimientos[ind2].cambioTratamientoActivo = true;
      let nuevoTx = {
        "idTratamiento":null,
        "idPadecimiento":null,
        "idDiente":null,
        "estatus": null,
        "idPtiTratamientoAnterior": tratamiento.idPtiTratamiento,
        "cantidad": 1,
        "nombreTratamiento": null,
        "numeroDiente": tratamiento.numeroDiente,
        "precioUnitario": null
      }
      this.propNoIniciadosNoInvertidos[ind1].listPadecimientos[ind2].listaPtiTratamiento.push(nuevoTx);
    },
    eliminarTratamientoIndex(index){
      this.listPadecimientosAgregar.splice(index, 1)
    },
  }

}
</script>

<style scoped>
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
.columnas-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-estatus-inicio {
  border-radius: 10px 0 0 10px;
  border-top: 1px solid;
  border-left: 1px solid;
  border-bottom: 1px solid
}

.border-estatus-medio {
  border-top: 1px solid;
  border-bottom: 1px solid
}

.border-estatus-final {
  border-radius: 0 10px 10px 0;
  border-top: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid
}
.cambiarTratamientoClass{
  border: 2px solid #81CDD8 !important;
  padding: 20px !important;
  border-radius: 15px !important;
}
.cambiarTratamientoNuevoClass{
  border: 2px solid #D6E7F3 !important;
  padding: 20px !important;
  border-radius: 15px !important;
}
</style>
